module.exports = __webpack_public_path__ + "img/nl.ee9b0bd3.svg";